// const Flickity = require('flickity');
require('flickity-fullscreen');
require('flickity-bg-lazyload');
const Flickity = require('flickity');
/**
 * Gallery component.
 * All DOM elements with classname '.js-gallery' will be Flickified.
 *
 * Usage:
 * Call Gallery.init() to initialize all galleries..
 *
 * Methods:
 *
 * init(): initializes on all $galleries
 */

const init = function() {
	const $galleries = document.querySelectorAll('.js-gallery');
	$galleries.forEach($gallery => {
		const $images = $gallery.querySelectorAll('.gallery-cell .js-gallery-image');

		// eslint-disable-next-line no-new
		const flkty = new Flickity($gallery, {
			fullscreen: true,
			cellSelector: '.gallery-cell',
			wrapAround: false,
			bgLazyLoad: 1,
			draggable: false,
			prevNextButtons: $images.length > 2,
			groupCells: false,
			pageDots: $images.length > 2,
			imagesLoaded: true,
			autoplay: false,
			cellAlign: 'left'
		});

		if ($images.length <= 2) {
			$gallery.classList.add('is-less-than');
		}

		$images.forEach(($image, index) => {
			$image.addEventListener('click', e => {
				flkty.selectCell(index);
				flkty.viewFullscreen();
				flkty.reloadCells();
				// setTimeout needed for recalculating the position of the slider after fullscreen view
				setTimeout(() => {
					flkty.resize();
				}, 100);
			});
		});
	});
};

module.exports = {
	init
};
